import React, { useState } from "react";
import { LifebuoyIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import Input from "src/components/form/Input";
import Button from "src/components/form/Button";

export const TotpRecoveryForm = ({ onRecoverySubmit, onCancel, site, disabled }) => {
  const [recoveryCode, setRecoveryCode] = useState("");

  return (
    <div className="animate-2fa-fade w-full space-y-4">
      <div className="text-center">
        <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-blue-50 text-blue-600">
          <LifebuoyIcon className="h-6 w-6" />
        </div>
        <h3 className="text-sm font-bold text-gray-900">Account Recovery</h3>
        <p className="text-[11px] text-gray-500">Enter your backup recovery code to reset your authenticator.</p>
      </div>

      <Input
        inline
        label="Recovery Code"
        placeholder="e.g. A9F3-C2D1"
        inputValue={recoveryCode}
        onChange={(e) => setRecoveryCode(e.target.value.toUpperCase())}
        inputType="text"
        inputName="recovery_code"
      />

      <Button
        isDisable={disabled || recoveryCode.length < 4}
        buttonClasses="w-full"
        loading={disabled}
        buttonLabel="Reset Authenticator"
        buttonFunction={() => onRecoverySubmit(recoveryCode)}
        buttonStyles={{ borderColor: site?.highlight_color, backgroundColor: site?.highlight_color }}
      />

      <button
        onClick={onCancel}
        className="flex w-full items-center justify-center gap-1 text-[11px] font-semibold text-gray-500 hover:text-gray-900">
        <ArrowLeftIcon className="h-3 w-3" /> Back to OTP
      </button>
    </div>
  );
};
